import api from './api';

export interface AuditLog {
  id: number;
  action: string;
  entity_type?: string | null;
  entity_id?: number | null;
  user_id?: number | null;
  user_email?: string | null;
  details?: string | null;
  ip_address?: string | null;
  created_at?: string | null;
}

export interface AuditFilters {
  user_id?: number;
  entity_type?: string;
  days?: number;
  limit?: number;
}

export const auditService = {
  async getLogs(filters: AuditFilters = {}): Promise<AuditLog[]> {
    const params: Record<string, unknown> = {};
    if (filters.user_id) params.user_id = filters.user_id;
    if (filters.entity_type) params.entity_type = filters.entity_type;
    if (filters.days) params.days = filters.days;
    if (filters.limit) params.limit = filters.limit;
    const res = await api.get('/audit', { params });
    return res.data;
  },
};
